import { FormControl, Box, Text } from "@chakra-ui/react";
import { Option } from "@/types/productTypes";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import Select, { StylesConfig } from "react-select";
type SelectOptionProps = {
   option: Option;
};

const customStyles: StylesConfig = {
   control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "black" : "gray",
      boxShadow: state.isFocused ? "0 0 0 1px black" : "none",
      "&:hover": {
         borderColor: "black",
      },
      height: "3rem",
      fontSize: "1rem",
      paddingLeft: "1rem",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
   }),
   option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
         ? "gray"
         : state.isFocused
           ? "lightgray"
           : "white",
      color: state.isSelected ? "white" : "black",
      height: "3rem",
      fontSize: "1rem",
      display: "flex",
      alignItems: "center",
      paddingLeft: "24px",
      zIndex: 50,
   }),

   menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      marginTop: "0",
   }),
   menuList: (provided) => ({
      ...provided,
      padding: "0",
   }),
};
export default function SelectOption({ option }: SelectOptionProps) {
   const { watch, setValue } = useFormContext();
   const itemWatched = watch(option.optionId);

   useEffect(() => {
      if (itemWatched === undefined && option.items) {
         setValue(option.optionId, option.items[0].idName);
      }
   }, [option.optionId, itemWatched, option.items, setValue]);

   const handleChange = (selectedItem: any) => {
      setValue(option.optionId, selectedItem.value);
   };
   const mappedItems = option.items?.map((item) => ({
      value: item.idName,
      label: item.name,
   }));

   return (
      <FormControl onChange={handleChange}>
         <Box mb="1rem">
            <Text as="b" fontSize="sm">
               {option.name.toUpperCase()}
            </Text>
            <Select
               value={mappedItems?.find((item) => item.value === itemWatched)}
               onChange={handleChange}
               options={mappedItems}
               styles={customStyles}
               isSearchable={false}
            />
         </Box>
      </FormControl>
   );
}
